import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import { HelmetProvider } from 'react-helmet-async';
import Cookies from 'js-cookie';
import './index.css';
import App from './App';
import { initializeFirebaseAnalytics } from './firebase';
import reportWebVitals from './reportWebVitals';

// Functions to initialize analytics
export const initializeAnalytics = () => {
  if (!window.gaInitialized) {
    ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
    window.gaInitialized = true;
  }
  initializeFirebaseAnalytics();
};

// Conditionally initialize analytics based on cookie consent
if (Cookies.get('enteeonCookieConsent') === 'true') {
  initializeAnalytics();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
